import MultiGrid from './MultiGrid';

export default MultiGrid;
export { MultiGrid };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-virtualized/dist/es/MultiGrid/index.js
// module id = 650
// module chunks = 0